<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28" height="28"
	 viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
<g>
	<g>
		<g>
			<path class="st0" d="M14,14c0.7-0.2,1.3-0.6,1.9-1.1c0.1-0.1,0.2-0.2,0.3-0.3c1.2-1.5,1.2-3.7,0-5.2c-0.8-1.1-2.1-1.6-3.5-1.6
				c-1,0.1-2-0.3-2.7-1L5.6,0.5C5-0.2,4-0.2,3.4,0.5L0.5,3.4C-0.2,4-0.2,5,0.5,5.6L4.8,10c0.7,0.7,1,1.7,1,2.7
				c-0.1,1.3,0.5,2.6,1.6,3.5c0.8,0.6,1.7,0.9,2.6,0.9c0.9,0,1.9-0.3,2.6-0.9C13.3,15.6,13.8,14.8,14,14z M12.2,13.1
				c0,0.6-0.3,1.2-0.8,1.6c0,0,0,0,0,0c-0.8,0.7-2,0.7-2.8,0c-0.6-0.5-0.9-1.2-0.8-1.9c0.1-1.6-0.5-3.1-1.5-4.2L2.1,4.5l2.4-2.4
				l4.1,4.1c1.1,1.1,2.6,1.6,4.2,1.5c0.7,0,1.4,0.3,1.9,0.8c0.7,0.8,0.6,2,0,2.8c0,0.1-0.1,0.1-0.2,0.2c-0.4,0.4-0.9,0.6-1.4,0.6
				C12.6,12.2,12.2,12.6,12.2,13.1z"/>
			<path class="st0" d="M29.5,24.4L25.2,20c-0.7-0.7-1-1.7-1-2.7c0.1-1.3-0.5-2.6-1.6-3.5c-1.5-1.2-3.7-1.2-5.2,0
				c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1.2-1.1,1.9c-0.8,0.2-1.6,0.7-2.2,1.4c-1.2,1.5-1.2,3.7,0,5.2c0.8,1.1,2.1,1.6,3.5,1.6
				c1-0.1,2,0.3,2.7,1l4.4,4.4c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.2,1.1-0.5l2.9-2.9C30.2,26,30.2,25,29.5,24.4z M25.5,27.9
				l-4.1-4.1c-1-1-2.4-1.5-3.8-1.5c-0.1,0-0.2,0-0.3,0c-0.7,0-1.4-0.3-1.9-0.8c-0.7-0.8-0.6-2,0-2.8l0,0c0.4-0.5,1-0.8,1.6-0.8
				c0.5,0,0.8-0.4,0.9-0.9c0-0.5,0.3-1,0.7-1.4c0.1-0.1,0.1-0.1,0.2-0.2c0.8-0.7,2-0.7,2.8,0c0.6,0.5,0.9,1.2,0.8,1.9
				c-0.1,1.6,0.5,3.1,1.5,4.2l4.1,4.1L25.5,27.9z"/>
		</g>
	</g>
</g>
</svg>

</template>

<script>
    export default {
        name: "MS_svg"
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/chapter/MS_svg.vue